var TNB = {
  state: {
    tallSizingActive: false,
    lastSize: null,
  },
  sliderArrows: function () {
    const handleClickNext = function (e) {
      const parent = $(e.currentTarget).closest('.collection');
      const slider = parent.find('slider-component > ul');
      const items = slider.find('li');

      const scrollLeft = slider.get(0).scrollLeft;
      const itemWidth = items.get(0).scrollWidth;

      slider.get(0).scrollTo({
        left: scrollLeft + itemWidth,
        behavior: 'smooth',
      });

      parent.find('.slider-button--prev').removeAttr('disabled');

      if (scrollLeft + itemWidth >= slider.get(0).scrollWidth - slider.get(0).clientWidth) {
        parent.find('.slider-button--next').attr('disabled', '');
      }
    };

    const handleClickPrev = function (e) {
      const parent = $(e.currentTarget).closest('.collection');
      const slider = parent.find('slider-component > ul');
      const items = slider.find('li');

      const scrollLeft = slider.get(0).scrollLeft;
      const itemWidth = items.get(0).scrollWidth;

      slider.get(0).scrollTo({
        left: scrollLeft - itemWidth,
        behavior: 'smooth',
      });

      parent.find('.slider-button--next').removeAttr('disabled');

      if (scrollLeft - itemWidth * 2 <= 0) {
        parent.find('.slider-button--prev').attr('disabled', '');
      }
    };

    $('body').on('click', '.collection__arrows .slider-button--prev', handleClickPrev);
    $('body').on('click', '.collection__arrows .slider-button--next', handleClickNext);
  },
  megaMenuHover: function () {
    const inlineMenu = document.querySelector('.header__inline-menu');
    if (!inlineMenu) return;

    const detailsItems = inlineMenu.querySelectorAll('details');

    detailsItems.forEach((item) => {
      const summary = item.querySelector('summary');
      const ulElement = item.querySelector('ul');

      const openMenu = () => {
        item.setAttribute('open', true);
        if (summary) {
          summary.setAttribute('aria-expanded', 'true');
        }
      };

      const closeMenu = () => {
        item.removeAttribute('open');
        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
        }
      };

      item.addEventListener('mouseenter', openMenu);
      item.addEventListener('mouseleave', closeMenu);
      if (ulElement) {
        ulElement.addEventListener('mouseleave', closeMenu);
      }
    });
  },
  tallSizingControls: function () {
    // Move the selection to the same size in the other length (L-Tall <-> L) so the pills and Add to Cart stay in sync
    function selectMatchingSize(controls, tall) {
      var checked = controls.parentNode.querySelector('input[name^="Size"]:checked');
      if (!checked || checked.hasAttribute('data-tall-size') === tall) return;

      var matchingValue = tall ? checked.value + '-Tall' : checked.value.replace(/-Tall$/, '');
      var match = Array.from(controls.parentNode.querySelectorAll('input[name="' + checked.name + '"]')).find(
        function (input) {
          return input.value === matchingValue;
        },
      );
      var label = match && controls.parentNode.querySelector('label[for="' + match.id + '"]');
      if (label) label.click();
    }

    function handleClickControl(controls, tall, userInitiated) {
      var regularOptions = controls.parentNode.querySelectorAll('label:not([data-tall-size])');
      var tallOptions = controls.parentNode.querySelectorAll('label[data-tall-size]');
      var buttonRegular = controls.querySelector('[data-button-regular]');
      var buttonTall = controls.querySelector('[data-button-tall]');

      regularOptions.forEach(function (el) {
        el.classList.add('hide');
      });
      tallOptions.forEach(function (el) {
        el.classList.add('hide');
      });

      buttonRegular.classList.add('inactive');
      buttonTall.classList.add('inactive');
      TNB.state.tallSizingActive = false;

      if (tall) {
        tallOptions.forEach(function (el) {
          el.classList.remove('hide');
        });

        buttonTall.classList.remove('inactive');

        TNB.state.tallSizingActive = true;
      } else {
        regularOptions.forEach(function (el) {
          el.classList.remove('hide');
        });

        buttonRegular.classList.remove('inactive');
      }

      if (userInitiated) selectMatchingSize(controls, tall);
    }

    $('body').on('click', '.tall-sizing-controls [data-button-regular]', function (e) {
      const target = $(e.currentTarget);
      const controls = target.closest('.tall-sizing-controls').get(0);
      handleClickControl(controls, false, !e.isTrigger);
    });

    $('body').on('click', '.tall-sizing-controls [data-button-tall]', function (e) {
      const target = $(e.currentTarget);
      const controls = target.closest('.tall-sizing-controls').get(0);
      handleClickControl(controls, true, !e.isTrigger);
    });
  },
  refreshTallSizingControls: function () {
    if (TNB.state.tallSizingActive) {
      $('[data-button-tall]').click();
    }
  },
  // A PDP can open with a Tall size preselected (?variant=), so match the toggle and pills to it
  syncTallSizingToSelection: function () {
    $('.tall-sizing-controls').each(function () {
      if (this.parentNode.querySelector('input[data-tall-size]:checked')) {
        $(this).find('[data-button-tall]').click();
      }
    });
  },
  // A color without Tall sizes comes back with nothing selected when a Tall size was carried over; pick the regular match
  restoreSizeAfterColorSwap: function () {
    const lastSize = TNB.state.lastSize;
    TNB.state.lastSize = null;
    if (!lastSize) return;

    // The previous variant-selects stays in the DOM, hidden, for a moment after a swap; use the visible one
    const picker = Array.from(document.querySelectorAll('variant-selects')).find((el) => el.offsetWidth > 0);
    if (!picker) return;

    const sizeInputs = Array.from(picker.querySelectorAll('input[name^="Size"]'));
    if (!sizeInputs.length || sizeInputs.some((input) => input.checked)) return;

    const match = sizeInputs.find((input) => input.value === lastSize.replace(/-Tall$/, ''));
    const label = match && document.querySelector(`label[for="${match.id}"]`);
    if (label) label.click();
  },
};

function init() {
  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (e) {
    const checkedSize = document.querySelector('variant-selects input[name^="Size"]:checked');
    TNB.state.lastSize = checkedSize ? checkedSize.value : null;
    TNB.refreshTallSizingControls();
  });

  TNB.tallSizingControls();
  TNB.syncTallSizingToSelection();
  // Picking a size re-renders variant-selects, which comes back on Regular; re-sync once the new one lands
  new MutationObserver(function (mutations) {
    const rerendered = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        return node.nodeType === Node.ELEMENT_NODE && (node.matches('variant-selects') || node.querySelector('variant-selects'));
      });
    });
    if (rerendered) {
      TNB.syncTallSizingToSelection();
      TNB.restoreSizeAfterColorSwap();
    }
  }).observe(document.body, { childList: true, subtree: true });
  TNB.megaMenuHover();
  TNB.sliderArrows();

  const productCount = document.querySelector('#ProductCount');
  const productCountDesktop = document.querySelector('#ProductCountDesktop');
  const outOfStockProducts = document.querySelectorAll('.product-grid [data-in-stock="false"]');

  if (productCount) {
    const count = productCount.innerText;
    const parsedCount = parseInt(count);

    productCount.innerText = parsedCount - outOfStockProducts.length + ' products';
    productCount.style.display = 'block';
  }

  if (productCountDesktop) {
    const count = productCountDesktop.innerText;
    const parsedCount = parseInt(count);

    productCountDesktop.innerText = parsedCount - outOfStockProducts.length + ' products';
    productCountDesktop.style.display = 'block';
  }

  const headerMenuItems = document.querySelectorAll('summary.header__menu-item');
  const handleMenuItemClick = (e) => {
    const target = e.target.closest('summary.header__menu-item');

    if (target) {
      const href = target.getAttribute('data-href');
      const parent = target.closest('details');

      if (href) {
        e.preventDefault();
        e.stopPropagation();
        window.location = href;

        if (parent) {
          requestAnimationFrame(() => {
            parent.setAttribute('open', 'true');
          })
        }
      }
    }
  }

  headerMenuItems.forEach((menuItem) => {
    menuItem.addEventListener('mouseup', handleMenuItemClick);
  });

  // Add fit confidence messaging to specifications section PDP
  const INLINE_STRONGS = [
    "not sure if it fits?",
    "free exchanges",
    "easy 30-day returns",
  ];
  function isInlineStrong(node) {
    return (
      node.nodeType === Node.ELEMENT_NODE &&
      node.tagName === "STRONG" &&
      INLINE_STRONGS.includes(node.textContent.trim().toLowerCase())
    );
  }
  function trimTrailing(nodes, start, end) {
    let i = end;
    while (i > start) {
      const prev = nodes[i - 1];
      const isBr = prev.nodeType === Node.ELEMENT_NODE && prev.tagName === "BR";
      const isWhitespace = prev.nodeType === Node.TEXT_NODE && prev.textContent.trim() === "";
      if (isBr || isWhitespace) i--;
      else break;
    }
    return i;
  }
  function handleSpecsAccordionManipulation() {
    const accordionTitles = document.querySelectorAll(
      ".product__accordion .accordion__title",
    );
    let specificationsElement = null;
    accordionTitles.forEach((title) => {
      if (title.innerText.trim().toLowerCase() === "specifications") {
        specificationsElement = title;
      }
    });
    if (!specificationsElement) return;
    const accordionItem = specificationsElement.closest(".product__accordion");
    const accordionContent = accordionItem
      ? accordionItem.querySelector(".accordion__content")
      : null;
    if (!accordionContent) return;
    if (accordionContent.querySelector(".fit-confidence-message")) return;
    const paragraphs = accordionContent.querySelectorAll("p");
    for (const p of paragraphs) {
      if (!p.textContent.includes("Not sure if it fits?")) continue;
      const childNodes = Array.from(p.childNodes);
      const anchorIndex = childNodes.findIndex(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          node.tagName === "STRONG" &&
          node.textContent.trim().toLowerCase().startsWith("not sure if it fits"),
      );
      if (anchorIndex === -1) continue;
      const endIndex = childNodes.findIndex(
        (node, i) =>
          i > anchorIndex &&
          node.nodeType === Node.ELEMENT_NODE &&
          node.tagName === "STRONG" &&
          !isInlineStrong(node),
      );
      const parent = p.parentNode;
      const wrapper = document.createElement("div");
      wrapper.classList.add("fit-confidence-message");
      const hasBefore = anchorIndex > 0;
      const hasAfter = endIndex !== -1;
      if (!hasBefore && !hasAfter) {
        parent.insertBefore(wrapper, p);
        wrapper.appendChild(p);
      } else {
        const beforeEnd = trimTrailing(childNodes, 0, anchorIndex);
        const fitEnd = trimTrailing(childNodes, anchorIndex, hasAfter ? endIndex : childNodes.length);
        if (beforeEnd > 0) {
          const beforeP = document.createElement("p");
          for (let i = 0; i < beforeEnd; i++) {
            beforeP.appendChild(childNodes[i]);
          }
          parent.insertBefore(beforeP, p);
        }
        for (let i = beforeEnd; i < anchorIndex; i++) {
          if (childNodes[i].parentNode) childNodes[i].remove();
        }
        const fitP = document.createElement("p");
        for (let i = anchorIndex; i < fitEnd; i++) {
          fitP.appendChild(childNodes[i]);
        }
        wrapper.appendChild(fitP);
        parent.insertBefore(wrapper, p);
        const gapEnd = hasAfter ? endIndex : childNodes.length;
        for (let i = fitEnd; i < gapEnd; i++) {
          if (childNodes[i].parentNode) childNodes[i].remove();
        }
        if (!p.hasChildNodes() || p.textContent.trim() === "") {
          p.remove();
        }
      }
      return;
    }
  }

  handleSpecsAccordionManipulation();
  document.addEventListener("product-info:loaded", handleSpecsAccordionManipulation);
}

window.addEventListener('DOMContentLoaded', function () {
  init();
});
